import { BidDTO } from "./bidDTO";

export class AuctionBidDTO extends BidDTO{
    
    public partialUserName!:string;
    public rank?:number;
    public requestorId?:string;

    constructor(){
        super();
    }
}